export default Object.freeze({
    PHYSICIAN: {
        ID: 1,
        NAME: 'Physician',
    },
    PHYSICIAN_ASSISTANT: {
        ID: 2,
        NAME: 'Physician Assistant / Nurse Practitioner',
    },
    MEDICAL_ASSISTANT: {
        ID: 3,
        NAME: 'Medical Assistant / CNA',
    },
    NURSE: {
        ID: 4,
        NAME: 'Nurse',
    },
    OFFICE_MANAGER: {
        ID: 5,
        NAME: 'Office Manager / Administrator',
    },
    CLERK: {
        ID: 6,
        NAME: 'Clerk',
    },
    ADMINISTRATOR: {
        ID: 7,
        NAME: 'Administrator',
    },
})
